(() => {
// ======== DOM References ========
const $4995a77b6e681b21$var$certificateForm = document.querySelector('.certificate-form form');
const $4995a77b6e681b21$var$skipButton = $4995a77b6e681b21$var$certificateForm.querySelector('.hande-skip-certificate');
const $4995a77b6e681b21$var$finalButton = $4995a77b6e681b21$var$certificateForm.querySelector('.ceritificate-proceed');
const $4995a77b6e681b21$var$overlay = document.querySelector('.certificate-wrapper');
const $4995a77b6e681b21$var$closeButtons = document.querySelectorAll('.close-certificate-popup, .certificate-overlay');
let $4995a77b6e681b21$var$formId = null;
let $4995a77b6e681b21$var$productId = null;
let $4995a77b6e681b21$var$productTitle = null;
let $4995a77b6e681b21$var$productMeta = {};
// ======== Utility Functions ========
// Helper: dispatch granular certificate field events
function $4995a77b6e681b21$var$dispatchCertificateFieldEvent(eventName, extraDetail = {}) {
    if (!$4995a77b6e681b21$var$productId || !$4995a77b6e681b21$var$productTitle) return;
    const hasPriceMeta = $4995a77b6e681b21$var$productMeta && $4995a77b6e681b21$var$productMeta.price;
    const ecommerce = hasPriceMeta ? {
        currency: $4995a77b6e681b21$var$productMeta.currency || window.Shopify && Shopify.currency && Shopify.currency.active || '',
        value: Number($4995a77b6e681b21$var$productMeta.price) || 0,
        items: [
            {
                imageURL: $4995a77b6e681b21$var$productMeta.imageURL || '',
                item_brand: $4995a77b6e681b21$var$productMeta.itemBrand || '',
                item_category: $4995a77b6e681b21$var$productMeta.itemCategory || '',
                item_id: String($4995a77b6e681b21$var$productMeta.itemId || $4995a77b6e681b21$var$productId || ''),
                item_name: $4995a77b6e681b21$var$productMeta.itemName || $4995a77b6e681b21$var$productTitle || '',
                item_sku: $4995a77b6e681b21$var$productMeta.itemSku || '',
                item_variant: String($4995a77b6e681b21$var$productMeta.itemVariant || ''),
                price: Number($4995a77b6e681b21$var$productMeta.price) || 0,
                quantity: 1,
                variant_name: $4995a77b6e681b21$var$productMeta.variantName || ''
            }
        ]
    } : undefined;
    window.dispatchEvent(new CustomEvent(eventName, {
        detail: {
            product_id: $4995a77b6e681b21$var$productId,
            product_name: $4995a77b6e681b21$var$productTitle,
            collection: $4995a77b6e681b21$var$productMeta.collection || '',
            ecomm_pagetype: 'product',
            ecommerce: ecommerce,
            ...extraDetail
        }
    }));
}
// Show the certificate popup
function $4995a77b6e681b21$var$openCertificatePopup(targetFormId, productIdValue, productTitleValue) {
    $4995a77b6e681b21$var$formId = targetFormId;
    $4995a77b6e681b21$var$productId = productIdValue;
    $4995a77b6e681b21$var$productTitle = productTitleValue;
    document.body.classList.add('overflow-hidden');
    $4995a77b6e681b21$var$overlay.style.display = 'flex';
    window.dispatchEvent(new CustomEvent('certificateStarted', {
        detail: {
            productId: productIdValue,
            productTitle: productTitleValue
        }
    }));
}
// Hide the certificate popup and reset form
function $4995a77b6e681b21$var$closeCertificatePopup() {
    $4995a77b6e681b21$var$certificateForm.reset();
    $4995a77b6e681b21$var$finalButton.setAttribute('disabled', 'true');
    $4995a77b6e681b21$var$overlay.style.display = 'none';
    document.body.classList.remove('overflow-hidden');
}
// Check if all required fields are filled
function $4995a77b6e681b21$var$checkRequiredFields() {
    const requiredFields = $4995a77b6e681b21$var$certificateForm.querySelectorAll('[required]');
    const allFilled = Array.from(requiredFields).every((field)=>field.value);
    $4995a77b6e681b21$var$finalButton.disabled = !allFilled;
}
// Toggle visibility of "gift from" field based on selection
function $4995a77b6e681b21$var$toggleGiftFromField() {
    const isGift = document.querySelector('input[name="properties[_is_gift]"]:checked')?.value;
    const giftFromGroup = document.querySelector('.gift-from');
    const giftFromInput = giftFromGroup.querySelector('input');
    if (isGift === 'Yes') {
        giftFromGroup.classList.remove('hidden');
        giftFromInput.required = true;
    } else {
        giftFromGroup.classList.add('hidden');
        giftFromInput.required = false;
    }
}
// Transfer data from certificate form to hidden fields in target form
function $4995a77b6e681b21$var$transferFormData() {
    const mainForm = document.getElementById($4995a77b6e681b21$var$formId);
    const hiddenInputs = mainForm.querySelectorAll('.certificate-hidden-data');
    hiddenInputs.forEach((input)=>{
        if (input.name === 'properties[_accepts_greetings]') input.value = $4995a77b6e681b21$var$certificateForm.querySelector(`input[name="${input.name}"]`)?.checked || false;
        else {
            const value = $4995a77b6e681b21$var$certificateForm.querySelector(`input[name="${input.name}"]`)?.value || '';
            input.value = value;
        }
    });
    // Trigger the original product form submission
    mainForm.querySelector('.product-form__submit, .product-card__atc')?.click();
}
function $4995a77b6e681b21$var$handleTextInputs(certificateForm) {
    if (!certificateForm) return;
    const nameInput = certificateForm.querySelector('#name-input');
    const nameError = certificateForm.querySelector('#name-error');
    const ownerInput = certificateForm.querySelector('#owner-input');
    const ownerError = certificateForm.querySelector('#owner-error');
    $4995a77b6e681b21$var$handleInput(nameInput, nameError);
    $4995a77b6e681b21$var$handleInput(ownerInput, ownerError);
}
function $4995a77b6e681b21$var$handleInput(input, error) {
    if (!input || !error) return;
    const max_chars = input.maxLength;
    input.addEventListener('input', (e)=>{
        if (e.target.value.length === max_chars) error.classList.remove('visibility-hidden');
        else error.classList.add('visibility-hidden');
    });
}
$4995a77b6e681b21$var$handleTextInputs($4995a77b6e681b21$var$certificateForm);
// ======== Event Listeners ========
// Dynamically handle clicks on certificate trigger buttons
document.body.addEventListener('click', (e)=>{
    const button = e.target.closest('.trigger-certificate-modal-button');
    if (!button) return;
    const dataset = button.dataset || {};
    $4995a77b6e681b21$var$productMeta = {
        collection: dataset.collectionHandle || '',
        currency: dataset.productCurrency || '',
        price: dataset.productPrice || '',
        imageURL: dataset.productImage || '',
        itemBrand: dataset.productVendor || '',
        itemCategory: dataset.productType || '',
        itemId: dataset.productId || '',
        itemName: dataset.productTitle || '',
        itemSku: dataset.productSku || '',
        itemVariant: dataset.productVariantId || '',
        variantName: dataset.productVariantTitle || ''
    };
    $4995a77b6e681b21$var$openCertificatePopup(button.dataset.targetForm, button.dataset.productId, button.dataset.productTitle);
});
// Handle close popup click
$4995a77b6e681b21$var$closeButtons?.forEach((button)=>{
    button.addEventListener('click', $4995a77b6e681b21$var$addToCartWithoutCertificate);
});
// Validate form on input (no tracking here, just UX)
$4995a77b6e681b21$var$certificateForm.addEventListener('input', ()=>{
    $4995a77b6e681b21$var$toggleGiftFromField();
    $4995a77b6e681b21$var$checkRequiredFields();
});
// Handle certificate form submission
$4995a77b6e681b21$var$certificateForm.addEventListener('submit', (e)=>{
    e.preventDefault();
    // Dispatch event when certificate form is submitted with all data
    window.dispatchEvent(new CustomEvent('certificateSubmitted', {
        detail: {
            productId: $4995a77b6e681b21$var$productId,
            productTitle: $4995a77b6e681b21$var$productTitle,
            formData: new FormData($4995a77b6e681b21$var$certificateForm)
        }
    }));
    $4995a77b6e681b21$var$transferFormData();
    $4995a77b6e681b21$var$closeCertificatePopup();
});
$4995a77b6e681b21$var$skipButton?.addEventListener('click', $4995a77b6e681b21$var$addToCartWithoutCertificate);
// ======== Field-level tracking ========
// Fire tracking for text fields on blur (not on every keystroke)
const $4995a77b6e681b21$var$bearNameInputField = $4995a77b6e681b21$var$certificateForm.querySelector('#name-input');
const $4995a77b6e681b21$var$belongsToInputField = $4995a77b6e681b21$var$certificateForm.querySelector('#owner-input');
const $4995a77b6e681b21$var$giftFromInputField = $4995a77b6e681b21$var$certificateForm.querySelector('.gift-from input');
if ($4995a77b6e681b21$var$bearNameInputField) $4995a77b6e681b21$var$bearNameInputField.addEventListener('blur', (event)=>{
    const value = event.target.value || '';
    $4995a77b6e681b21$var$dispatchCertificateFieldEvent('certificateBearNameChanged', {
        bear_name: value
    });
});
if ($4995a77b6e681b21$var$belongsToInputField) $4995a77b6e681b21$var$belongsToInputField.addEventListener('blur', (event)=>{
    const value = event.target.value || '';
    $4995a77b6e681b21$var$dispatchCertificateFieldEvent('certificateBelongsToNameChanged', {
        belongs_to_name: value
    });
});
if ($4995a77b6e681b21$var$giftFromInputField) $4995a77b6e681b21$var$giftFromInputField.addEventListener('blur', (event)=>{
    const value = event.target.value || '';
    $4995a77b6e681b21$var$dispatchCertificateFieldEvent('certificateGiftGiverChanged', {
        gift_giver_name: value
    });
});
// Gift (is gift true/false)
const $4995a77b6e681b21$var$giftRadios = $4995a77b6e681b21$var$certificateForm.querySelectorAll('input[name="properties[_is_gift]"]');
$4995a77b6e681b21$var$giftRadios.forEach((radio)=>{
    radio.addEventListener('change', ()=>{
        const selected = $4995a77b6e681b21$var$certificateForm.querySelector('input[name="properties[_is_gift]"]:checked');
        const isGift = selected ? selected.value === 'Yes' : false;
        $4995a77b6e681b21$var$dispatchCertificateFieldEvent('certificateIsGiftChanged', {
            is_gift: isGift
        });
    });
});
// Bear and "belonger" birthdays (first and second date inputs in the certificate form)
const $4995a77b6e681b21$var$dateInputs = $4995a77b6e681b21$var$certificateForm.querySelectorAll('input[type="date"]');
const $4995a77b6e681b21$var$bearBirthdayInput = $4995a77b6e681b21$var$dateInputs[0];
const $4995a77b6e681b21$var$belongsToBirthdayInput = $4995a77b6e681b21$var$dateInputs[1];
if ($4995a77b6e681b21$var$bearBirthdayInput) $4995a77b6e681b21$var$bearBirthdayInput.addEventListener('blur', (event)=>{
    const value = event.target.value || '';
    $4995a77b6e681b21$var$dispatchCertificateFieldEvent('certificateBearBirthdayChanged', {
        bear_birthday_date: value
    });
});
if ($4995a77b6e681b21$var$belongsToBirthdayInput) $4995a77b6e681b21$var$belongsToBirthdayInput.addEventListener('blur', (event)=>{
    const value = event.target.value || '';
    $4995a77b6e681b21$var$dispatchCertificateFieldEvent('certificateBelongsToBirthdayChanged', {
        belongs_to_birthday_date: value
    });
});
function $4995a77b6e681b21$var$addToCartWithoutCertificate() {
    if (!$4995a77b6e681b21$var$formId) return;
    const mainForm = document.getElementById($4995a77b6e681b21$var$formId);
    mainForm?.querySelector('.product-form__submit, .product-card__atc').click();
    $4995a77b6e681b21$var$closeCertificatePopup();
}


if (!customElements.get('klaviyo-form-reload')) customElements.define('klaviyo-form-reload', class KlaviyoFormReload extends HTMLElement {
    constructor(){
        super();
        this.KLAVIYO_SRC = 'https://static.klaviyo.com/onsite/js/Y5frTe/klaviyo.js?company_id=Y5frTe';
        this.checkDelay = parseInt(this.dataset.checkDelay) || 2500;
    }
    connectedCallback() {
        setTimeout(()=>this.checkKlaviyo(), this.checkDelay);
    }
    isKlaviyoReady() {
        const k = window._klOnsite;
        // Not created or still a stub array
        if (!k || Array.isArray(k) && !k._loaded) return false;
        return true;
    }
    reloadKlaviyo() {
        console.log("Reloading Klaviyo\u2026");
        // Remove old script if exists
        const old = document.querySelector('script[src*="klaviyo.com/onsite/js"]');
        if (old) old.remove();
        // Create new script
        const script = document.createElement('script');
        script.src = this.KLAVIYO_SRC;
        script.async = true;
        document.head.appendChild(script);
        console.log('Klaviyo script inserted');
    }
    checkKlaviyo() {
        if (!this.isKlaviyoReady()) {
            console.log("Klaviyo failed to initialize, reloading\u2026");
            this.reloadKlaviyo();
            return;
        }
        console.log('Klaviyo initialized correctly');
    }
});



})();
//# sourceMappingURL=parcel_scripts.js.map
